import qs from 'query-string';

export const getQueryArray = (queryVal) => (Array.isArray(queryVal) ? queryVal : String(queryVal || '').split(','));
export const setQueryArray = (arr) => encodeURI(arr);

export const queryStringify = (obj, opts) => '?' + qs.stringify(obj, opts);
export const queryParse = (str, opts) => qs.parse(str, opts);
